import ahoy from 'ahoy.js'
import Fronternal from '../fronternal/fronternal.svelte'

ahoy.track('fronternal')

document.addEventListener('DOMContentLoaded', () => {
  const bridge = document.getElementById('fronternalbridge')
  const fronternal = new Fronternal({
    target: bridge,
    props: {
      name: 'Fronternal',
      shop: JSON.parse(bridge.getAttribute('shop')),
      controllerName: bridge.getAttribute('controller_name'),
      controllerAction: bridge.getAttribute('controller_action'),
      userId: bridge.getAttribute('user_id')
    }
  });

  window.fonternal = fronternal;
})
